// ============================================================
// Super Admin Layout
// ============================================================
// Sidebar + Topbar + scrollable content area, dedicated for Super Admin.

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { SuperAdminSidebar } from '@/components/navigation/SuperAdminSidebar';
import { Topbar } from '@/components/navigation/Topbar';
import { tokens } from '@/theme/tokens';
import { useResponsive } from '@/hooks/useResponsive';
import useThemeStore from '@/store/themeStore';

export function SuperAdminLayout() {
  const { isMobileOrTablet } = useResponsive();
  const collapsed = useThemeStore((s) => s.sidebarCollapsed);

  const sidebarWidth = isMobileOrTablet
    ? 0
    : collapsed
    ? tokens.layout.sidebar.collapsedWidth
    : tokens.layout.sidebar.expandedWidth;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Super Admin Sidebar */}
      <SuperAdminSidebar />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${sidebarWidth}px)`,
          transition: `width ${tokens.transitions.normal}`,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {/* Topbar (reused, as it adapts to missing school/owner context) */}
        <Topbar />

        {/* Page Content */}
        <Box
          sx={{
            flex: 1,
            mt: `${tokens.layout.topbar.height}px`,
            p: { xs: 2, sm: 3 },
            backgroundColor: tokens.colors.background,
            overflowY: 'auto',
          }}
        >
          <Box
            sx={{
              width: '100%',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
